export const API_BASE = (window._env_ && window._env_.REACT_APP_API_BASE) || process.env.REACT_APP_API_BASE || '/api';